export default [
    'kw_sizeindex',
    'kw_sizeindex_shoes',
    'kw_main_color'
] 